import { render, staticRenderFns } from "./PetSelect.vue?vue&type=template&id=60c11a0d&scoped=true&"
import script from "./PetSelect.vue?vue&type=script&lang=js&"
export * from "./PetSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c11a0d",
  null
  
)

export default component.exports